module.exports = __webpack_public_path__ + "media/retinol-large.816a533c.mp4";